import {
  createBackInStockNotificationRequest as publicCreateBackInStockNotificationRequest,
  getBackInStockNotificationRequest as publicGetBackInStockNotificationRequest,
  deleteBackInStockNotificationRequest as publicDeleteBackInStockNotificationRequest,
  markAsNotificationSent as publicMarkAsNotificationSent,
  queryBackInStockNotificationRequests as publicQueryBackInStockNotificationRequests,
  typedQueryBackInStockNotificationRequests as publicTypedQueryBackInStockNotificationRequests,
  getBackInStockNotificationRequestsCountByCatalogReferences as publicGetBackInStockNotificationRequestsCountByCatalogReferences,
  reportItemsBackInStock as publicReportItemsBackInStock,
} from './ecom-v1-back-in-stock-notification-request-back-in-stock-notifications.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  BackInStockNotificationRequestQuery,
  RequestsQueryBuilder,
  typedQueryBackInStockNotificationRequests as universalTypedQueryBackInStockNotificationRequests,
} from './ecom-v1-back-in-stock-notification-request-back-in-stock-notifications.universal.js';
import { onBackInStockNotificationRequestCreated as publicOnBackInStockNotificationRequestCreated } from './ecom-v1-back-in-stock-notification-request-back-in-stock-notifications.public.js';
import { onBackInStockNotificationRequestDeleted as publicOnBackInStockNotificationRequestDeleted } from './ecom-v1-back-in-stock-notification-request-back-in-stock-notifications.public.js';
import { onBackInStockNotificationRequestUpdated as publicOnBackInStockNotificationRequestUpdated } from './ecom-v1-back-in-stock-notification-request-back-in-stock-notifications.public.js';

function customQueryBackInStockNotificationRequests(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () =>
      publicQueryBackInStockNotificationRequests(httpClient)(),
    typedQueryFunction: (query: BackInStockNotificationRequestQuery) =>
      publicTypedQueryBackInStockNotificationRequests(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): RequestsQueryBuilder;
  function overloadedQuery(
    query: BackInStockNotificationRequestQuery
  ): ReturnType<typeof universalTypedQueryBackInStockNotificationRequests>;
  function overloadedQuery(query?: BackInStockNotificationRequestQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createBackInStockNotificationRequest: MaybeContext<
  BuildRESTFunction<typeof publicCreateBackInStockNotificationRequest> &
    typeof publicCreateBackInStockNotificationRequest
> = /*#__PURE__*/ createRESTModule(publicCreateBackInStockNotificationRequest);
export const getBackInStockNotificationRequest: MaybeContext<
  BuildRESTFunction<typeof publicGetBackInStockNotificationRequest> &
    typeof publicGetBackInStockNotificationRequest
> = /*#__PURE__*/ createRESTModule(publicGetBackInStockNotificationRequest);
export const deleteBackInStockNotificationRequest: MaybeContext<
  BuildRESTFunction<typeof publicDeleteBackInStockNotificationRequest> &
    typeof publicDeleteBackInStockNotificationRequest
> = /*#__PURE__*/ createRESTModule(publicDeleteBackInStockNotificationRequest);
export const markAsNotificationSent: MaybeContext<
  BuildRESTFunction<typeof publicMarkAsNotificationSent> &
    typeof publicMarkAsNotificationSent
> = /*#__PURE__*/ createRESTModule(publicMarkAsNotificationSent);
export const getBackInStockNotificationRequestsCountByCatalogReferences: MaybeContext<
  BuildRESTFunction<
    typeof publicGetBackInStockNotificationRequestsCountByCatalogReferences
  > &
    typeof publicGetBackInStockNotificationRequestsCountByCatalogReferences
> = /*#__PURE__*/ createRESTModule(
  publicGetBackInStockNotificationRequestsCountByCatalogReferences
);
export const reportItemsBackInStock: MaybeContext<
  BuildRESTFunction<typeof publicReportItemsBackInStock> &
    typeof publicReportItemsBackInStock
> = /*#__PURE__*/ createRESTModule(publicReportItemsBackInStock);
export const queryBackInStockNotificationRequests: MaybeContext<
  BuildRESTFunction<typeof customQueryBackInStockNotificationRequests> &
    typeof customQueryBackInStockNotificationRequests
> = /*#__PURE__*/ createRESTModule(customQueryBackInStockNotificationRequests);
/** */
export const onBackInStockNotificationRequestCreated: BuildEventDefinition<
  typeof publicOnBackInStockNotificationRequestCreated
> &
  typeof publicOnBackInStockNotificationRequestCreated = createEventModule(
  publicOnBackInStockNotificationRequestCreated
);
/** */
export const onBackInStockNotificationRequestDeleted: BuildEventDefinition<
  typeof publicOnBackInStockNotificationRequestDeleted
> &
  typeof publicOnBackInStockNotificationRequestDeleted = createEventModule(
  publicOnBackInStockNotificationRequestDeleted
);
/** */
export const onBackInStockNotificationRequestUpdated: BuildEventDefinition<
  typeof publicOnBackInStockNotificationRequestUpdated
> &
  typeof publicOnBackInStockNotificationRequestUpdated = createEventModule(
  publicOnBackInStockNotificationRequestUpdated
);

export {
  Status,
  SortOrder,
  WebhookIdentityType,
} from './ecom-v1-back-in-stock-notification-request-back-in-stock-notifications.universal.js';
export {
  BackInStockNotificationRequest,
  CatalogReference,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  CreateBackInStockNotificationRequestRequest,
  BackInStockItemDetails,
  FocalPoint,
  CreateBackInStockNotificationRequestResponse,
  GetBackInStockNotificationRequestRequest,
  GetBackInStockNotificationRequestResponse,
  DeleteBackInStockNotificationRequestRequest,
  DeleteBackInStockNotificationRequestResponse,
  MarkAsNotificationSentRequest,
  MarkAsNotificationSentResponse,
  QueryBackInStockNotificationRequestsRequest,
  PlatformQuery,
  PlatformQueryPagingMethodOneOf,
  Sorting,
  PlatformPaging,
  CursorPaging,
  QueryBackInStockNotificationRequestsResponse,
  PlatformPagingMetadata,
  Cursors,
  GetBackInStockNotificationRequestsCountByCatalogReferencesRequest,
  GetBackInStockNotificationRequestsCountByCatalogReferencesResponse,
  BackInStockNotificationRequestsCount,
  ReportItemsBackInStockRequest,
  ReportItemsBackInStockResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  BackInStockNotificationRequestCreatedEnvelope,
  BackInStockNotificationRequestDeletedEnvelope,
  BackInStockNotificationRequestUpdatedEnvelope,
  RequestsQueryResult,
  RequestsQueryBuilder,
  BackInStockNotificationRequestQuerySpec,
  ReportItemsBackInStockOptions,
} from './ecom-v1-back-in-stock-notification-request-back-in-stock-notifications.universal.js';
export { utils } from './ecom-v1-back-in-stock-notification-request-back-in-stock-notifications.universal.js';
export {
  StatusWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateBackInStockNotificationRequestApplicationErrors,
  MarkAsNotificationSentApplicationErrors,
  ReportItemsBackInStockApplicationErrors,
  CommonQueryWithEntityContext,
  BackInStockNotificationRequestQuery,
} from './ecom-v1-back-in-stock-notification-request-back-in-stock-notifications.universal.js';
